module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_oslo_viken_neg.cbd60fe8.svg";